import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Events, Classes, Elements } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Header ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.mobile.min.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 0,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === 1) ? this.classList.add('shrink') : this.classList.remove('shrink');
					}
				}
			});

			gsap.timeline({
				scrollTrigger: {
					start: () => $('.content-section:first-child').height(),
					onEnter: () => $Elements.body.addClass('menu-light'),
					onLeaveBack: () => $Elements.body.removeClass('menu-light')
				}
			});

			gsap.timeline({
				scrollTrigger: {
					start: 0,
					end: () => $('.content-section:first-child').height() + ($(this).height() * 2),
					toggleClass: {
						targets: this,
						className: 'force-shrink'
					}
				}
			});
		});

		Animations.mobile.max.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					onEnter: () => $Elements.body.addClass('menu-light'),
					onLeaveBack: () => $Elements.body.removeClass('menu-light')
				}
			});
		});
	});



	// ---------- Wine Packshot  ----------

	$('.wine-hero-section').each(function() {

		Animations.mobile.min.push(() => {

			const timeline = gsap.to('.packshot-image',{
				scrollTrigger: {
					trigger: '.wine-content-section',
					// markers: true,
					start: "top bottom",
					end: '50% 30%',
					pin: '.packshot-image',
					anticipatePin: 1,
				},
			});
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
